import Vue from 'vue'
import VueRouter from 'vue-router'

import OrdersView from '../views/OrdersView'
import VerboseOrderView from '../views/VerboseOrderView'
import NewOrderView from '../views/NewOrderView'
import GuestView from '../views/GuestsView.vue'
import GuestList from '../components/guests/GuestList.vue'
import NewGuest from '../components/guests/NewGuest.vue'
import Guest from '../components/guests/GuestInfo/Guest.vue'
import remoteOrder from '../views/reports/RemoteOrder.vue'
import GuestsReport from '../views/reports/GuestsReport.vue'
import CashReport from '../views/reports/CashReport.vue'
import DayPicture from '../views/reports/DayPicture.vue'
import DeliveryZonesReport from '../views/reports/DeliveryZonesReport.vue'
import Dashboard from '../views/reports/Dashboard.vue'
import DokuView from '../views/DokuView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/orders/'
  },
  {
    path: '/orders/new',
    component: NewOrderView
  },
  {
    path: '/orders',
    component: OrdersView,
    children: [  
      {
        path: ':orderId',
        component: VerboseOrderView
      }
    ]
  },
  {
    path: '/guests',
    component: GuestView,
    meta: {
      title: 'Гости',
      active: false
    },
    children: [  
      {
        name: 'GuestsList',
        path: '/',
        component: GuestList,
      },
      {
        path: ':guestId',
        name: 'Guest',
        params: true,
        component: Guest,
        meta: {
          title: "Гость"
        }
      },
      {
        name: 'NewGuest',
        path: '/create',
        component: NewGuest,
        meta: {
          title: 'Создание гостя'
        }
      }
    ]
  },
  {
    path: '/reports/remoteOrder',
    component: remoteOrder
  },
  {
    path: '/reports/guestsOrder',
    component: GuestsReport
  },
  {
    path: '/reports/cashReport',
    component: CashReport
  },
  {
    path: '/reports/dayPicture',
    component: DayPicture
  },
  {
    path: '/reports/deliveryZonesReport',
    component: DeliveryZonesReport
  },
  {
    path: '/reports/dashboard',
    component: Dashboard
  },
  {
    path: '/settings',
    component: () => import('../views/SettingsView'),
    redirect: '/settings/r-keeper',
    children: [
      {
        path: ':setting_page',
        component: () => import('../views/SettingsView'),
        children: [{
          path: ':arg'
        }]
      }
    ]
  },
  {
    path:'/documentation',
    component: DokuView
  }
]

const router = new VueRouter({
  routes
})

export default router
